
// components/journal/JournalMetrics.tsx
import React from 'react';
import { MetricInput } from './MetricInput';
import { useJournalMetrics } from '../../config/journalMetrics';
import type { JournalMetric } from '../../types/journal';

interface JournalMetricsProps {
  type: 'morning' | 'evening';
  values: Record<string, number>;
  onChange?: (field: string, value: number) => void;
  readonly?: boolean;
}

export function JournalMetrics({
  type,
  values,
  onChange,
  readonly
}: JournalMetricsProps) {
  const handleChange = (field: string) => (value: number) => {
    onChange?.(field, value);
  };

  const JOURNAL_METRICS = useJournalMetrics();
  const applicableMetrics = JOURNAL_METRICS.filter(
    metric => metric.type === type || metric.type === 'both'
  );

  return (
    <div className="space-y-6">
      {applicableMetrics.map((metric) => (
        <MetricInput
          key={metric.id}
          icon={metric.icon}
          label={metric.label}
          value={values?.[metric.id] || 0}
          onChange={handleChange(metric.id)}
          readonly={readonly}
        />
      ))}
    </div>
  );
}
